module.exports = __webpack_public_path__ + "static/media/lab-results.c1379c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/articles/lab-results.png
// module id = 1337
// module chunks = 1